/**
 * This file should be an exact mirror of helper3/filterString.js
 *
 * EXCPET: this uses import instead of require
 */
import handlebars from "handlebars";
import dayjs from "dayjs";
import JSON5 from "json5";
import { get } from "lodash";

/**
 * http://jsfiddle.net/mpetrovich/wMmHS/
 */
//eslint-disable-next-line
handlebars.registerHelper("math", function (lvalue, operator, rvalue, options) {
  lvalue = parseFloat(lvalue);
  rvalue = parseFloat(rvalue);

  return {
    "+": lvalue + rvalue,
    "-": lvalue - rvalue,
    "*": lvalue * rvalue,
    "/": lvalue / rvalue,
    "%": lvalue % rvalue,
  }[operator];
});

handlebars.registerHelper("lessThanNow", function (date) {
  let compareDate = new Date(date);

  if (compareDate.toString() === "Invalid Date") {
    throw new Error(`"${date}" is not a valid argument`);
  }

  return compareDate.getTime() < Date.now();
});

handlebars.registerHelper("moreThanNow", function (date) {
  let compareDate = new Date(date);

  if (compareDate.toString() === "Invalid Date") {
    throw new Error(`"${date}" is not a valid argument`);
  }

  return compareDate.getTime() > Date.now();
});

// Example: {{dateFormat "${d}" defaultToEmpty="true" format="YYYY"}}
handlebars.registerHelper("dateFormat", function (context, block) {
  try {
    var f = block.hash.format || "YYYY-MM-DD";
    const locale = block.hash.locale || "";
    const defaultToEmpty = block.hash.defaultToEmpty || "";
    if (locale) {
      require(`dayjs/locale/${locale}.js`);
      return dayjs(context).locale(locale).format(f);
    } else if (!context && defaultToEmpty) {
      return "";
    } else {
      return dayjs(context).format(f);
    }
  } catch (err) {
    console.error("dateFormat -", err);
  }
});
handlebars.registerHelper("signatureRequests", function (context) {
  try {
    const emails = get(context, "data.root.formData.signatureRequests", []);
    return emails
      .map((el) => el["email"])
      .join(",")
      .trim();
  } catch (err) {
    console.error("signatureRequests -", err);
  }
});

handlebars.registerHelper("dateTimeFormatUTC", function (context) {
  try {
    const utc = require("dayjs/plugin/utc");
    dayjs.extend(utc);
    return dayjs(context).utc().format();
  } catch (err) {
    console.error("dateTimeFormatUTC -", err);
  }
});

// Example: {{dateFormat "${d}" format="YYYY"}}
handlebars.registerHelper("dateToday", function (block) {
  var f = block.hash.format || "YYYY-MM-DD";
  const locale = block.hash.locale || "";
  if (locale) {
    require(`dayjs/locale/${locale}.js`);
    return dayjs().locale(locale).format(f);
  } else {
    return dayjs().format(f);
  }
});
/**
 * Display todats date in an ISO string. Very helpful if you want to set date and filter
 */
handlebars.registerHelper("dateTodayISO", function () {
  return dayjs().toISOString();
});

// Example: {{dateAdd "${d}" "1" "day" format="YYYY-MM-DD"}}
handlebars.registerHelper("dateAdd", function (date, number, unit, block) {
  try {
    var f = block.hash.format || "YYYY-MM-DD";
    const locale = block.hash.locale || "";
    if (locale) {
      require(`dayjs/locale/${locale}.js`);
      return dayjs(date).add(number, unit).locale(locale).format(f);
    } else {
      return dayjs(date).add(number, unit).format(f);
    }
  } catch (err) {
    console.error("dateAdd -", err);
  }
});

handlebars.registerHelper("dateSubtract", function (date, number, unit, block) {
  try {
    var f = block.hash.format || "YYYY-MM-DD";
    const locale = block.hash.locale || "";
    if (locale) {
      require(`dayjs/locale/${locale}.js`);
      return dayjs(date).subtract(number, unit).locale(locale).format(f);
    } else {
      return dayjs(date).subtract(number, unit).format(f);
    }
  } catch (err) {
    console.error("dateSubtract -", err);
  }
});

handlebars.registerHelper("json", function (context) {
  try {
    return JSON.stringify(context);
    //eslint-disable-next-line
  } catch (err) {
    return JSON5.stringify(context);
  }
});

handlebars.registerHelper("breaklines", function (text) {
  text = handlebars.Utils.escapeExpression(text);
  text = text.replace(/(\r\n|\n|\r)/gm, "<br>");
  return new handlebars.SafeString(text);
});

handlebars.registerHelper("typeof", function (value) {
  if (Array.isArray(value)) {
    return "array";
  }

  return typeof value;
});

handlebars.registerHelper("toFixed", function (distance) {
  return distance.toFixed(0);
});

handlebars.registerHelper("ifCond", function (v1, operator, v2, options) {
  switch (operator) {
    case "==":
      return v1 == v2 ? options.fn(this) : options.inverse(this);
    case "===":
      return v1 === v2 ? options.fn(this) : options.inverse(this);
    case "!=":
      return v1 != v2 ? options.fn(this) : options.inverse(this);
    case "!==":
      return v1 !== v2 ? options.fn(this) : options.inverse(this);
    case "<":
      return v1 < v2 ? options.fn(this) : options.inverse(this);
    case "<=":
      return v1 <= v2 ? options.fn(this) : options.inverse(this);
    case ">":
      return v1 > v2 ? options.fn(this) : options.inverse(this);
    case ">=":
      return v1 >= v2 ? options.fn(this) : options.inverse(this);
    case "&&":
      return v1 && v2 ? options.fn(this) : options.inverse(this);
    case "||":
      return v1 || v2 ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
});

handlebars.registerHelper("ifIn", function (elem, list, options) {
  if (list.indexOf(elem) > -1) {
    return options.fn(this);
  }
  return options.inverse(this);
});

handlebars.registerHelper("sum", function sum(value1, value2) {
  return Number(value1) + Number(value2);
});

handlebars.registerHelper("difference", function difference(value1, value2) {
  return Number(value1) - Number(value2);
});

handlebars.registerHelper(
  "multiplication",
  function multiplication(value1, value2) {
    return Number(value1) * Number(value2);
  }
);

handlebars.registerHelper("division", function division(value1, value2) {
  return Number(value1) / Number(value2);
});

handlebars.registerHelper("remainder", function remainder(value1, value2) {
  return Number(value1) % Number(value2);
});

handlebars.registerHelper("ceil", function ceil(value) {
  return Math.ceil(Number(value));
});

handlebars.registerHelper("floor", function floor(value) {
  return Math.floor(Number(value));
});

handlebars.registerHelper("abs", function abs(value) {
  return Math.abs(Number(value));
});

handlebars.registerHelper("excerpt", function excerpt(string, length) {
  length = parseInt(length) || 50;

  if (typeof string !== "string" || typeof length !== "number") {
    return string;
  }

  if (string.length < length) {
    return string;
  }

  return string.slice(0, length) + "...";
});

handlebars.registerHelper("sanitize", function sanitize(string) {
  string = string.replace(/[^\w\s]/gi, "").trim();

  return string.replace(/\s+/, "-").toLowerCase();
});

handlebars.registerHelper("newLineToBr", function newLineToBr(string) {
  return string.replace(/\r?\n|\r/g, "<br>");
});

handlebars.registerHelper("capitalizeEach", function capitalizeEach(string) {
  if (typeof string === "string") {
    return string.toLowerCase().replace(/\p{L}\S*/gu, function (match) {
      return match.charAt(0).toUpperCase() + match.slice(1);
    });
  }

  return string;
});

handlebars.registerHelper("capitalizeFirst", function capitalizeFirst(string) {
  if (typeof string === "string") {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return string;
});

handlebars.registerHelper("lowercase", function lowercase(param) {
  //eslint-disable-next-line
  return isString(param) ? param.toLowerCase() : param;
});

handlebars.registerHelper("uppercase", function uppercase(param) {
  //eslint-disable-next-line
  return isString(param) ? param.toUpperCase() : param;
});

handlebars.registerHelper("first", function first(collection) {
  //eslint-disable-next-line
  if (!isArray(collection) || collection.length === 0) {
    return "";
  }

  return collection[0];
});

handlebars.registerHelper("last", function last(collection) {
  //eslint-disable-next-line
  if (!isArray(collection) || collection.length === 0) {
    return "";
  }

  return collection[collection.length - 1];
});

handlebars.registerHelper("concat", function concat(...params) {
  // Ignore the object appended by handlebars.
  //eslint-disable-next-line
  if (isObject(params[params.length - 1])) {
    params.pop();
  }

  return params.join("");
});

handlebars.registerHelper("join", function join(params, delimiter) {
  //eslint-disable-next-line
  if (!delimiter || isObject(delimiter)) {
    delimiter = "";
  }
  //eslint-disable-next-line
  if (!isArray(params)) {
    return false;
  }

  return params.join(delimiter);
});

handlebars.registerHelper(
  "substring",
  function (passedString, startstring, endstring) {
    var theString = passedString.substring(startstring, endstring);
    return new handlebars.SafeString(theString);
  }
);

handlebars.registerHelper("age", function (pnr) {
  if (!pnr) {
    return "";
  }
  // This requires pnr to be formatted YYYYMMDD

  // force age to be string
  const _pnr = typeof pnr === "string" ? pnr : pnr.toString();

  const today = new Date();
  const birthDate = new Date(
    `${_pnr.slice(0, 4)}-${_pnr.slice(4, 6)}-${_pnr.slice(6, 8)}`
  );

  if (birthDate.toString() === "Invalid Date") {
    return "";
  }

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
});

handlebars.registerHelper("gender", function (pnr) {
  if (!pnr) {
    return "";
  }

  // This requires pnr to include at least the 2 last digits
  const _pnr = typeof pnr === "string" ? pnr : pnr.toString();

  if (!_pnr.length || _pnr.length < 2) {
    return "";
  }

  const genderNum = Number(_pnr[_pnr.length - 2]);

  return genderNum % 2 ? "M" : "F";
});

handlebars.registerHelper("reverse", (value) => {
  if (Array.isArray(value)) {
    return [...value].reverse();
  } else if (typeof value === "string") {
    return value.split("").reverse().join("");
  }
});

const filterString = (string, props, context) => {
  const {
    effects = {},
    user,
    userPersistentProfile,
    formData = {},
    configuration = {},
    queryParams = null,
  } = props;

  const _context = typeof context === "string" ? { value: context } : context;
  if (!string) {
    return;
  }

  try {
    const template = handlebars.compile(string);
    return template({
      orgName: configuration.name,
      portalName: configuration.name,
      metadata: configuration.metadata,
      view: effects.view,
      user,
      upp: userPersistentProfile,
      userPersistentProfile,
      queryParams: queryParams ? queryParams : context?.queryParams,
      formData,
      ..._context,
      effects,
    });
  } catch (err) {
    console.error("filterString", err);
    return string;
  }
};

export default filterString;
